import React from 'react';

interface Props {
  hit: object,
  components: any,
  attribute: string,
  route: string,
}

const SuggestedHit: React.FC<Props> = ({
  hit,
  components,
  attribute,
  route,
}) => {
  return (
    <a
      className="aa-ItemLink text-dark-gray"
      href={route}
    >
      <div className="aa-ItemContent">
        <div className="aa-ItemTitle">
          <components.Highlight
            hit={hit}
            attribute={attribute}
            highlightedTagName="mark"
            nonHighlightedTagName="span"
          />
        </div>
      </div>
    </a>
  );
};

export default SuggestedHit;
